/* eslint-disable camelcase */
import {Component} from '@src/lib/San';
import $style from './index.module.less';
const guideLogo = 'https://newapp-prompt.cdn.bcebos.com/bgimg/2026-01/c0520a37dc4fb2d725b4f29e476efe95.png';

export class CHeadDeflector extends Component {
    static template = `
        <div
            class="{{$style.headDeflector}}"
        >
            <div class="{{$style.guide}}">
                <div class="{{$style.guideLogo}}" style="background-image: url({{guideLogo}});"></div>
                <slot name="guideButton">
                    <div
                        s-ref="guideButton"
                        class="{{$style.guideButton}}"
                        on-click="handleGuideButtonClick"
                    >
                        {{ btnText || '打开APP体验' }}
                    </div>
                </slot>
            </div>
        </div>
    `;
    initData() {
        return {
            $style,
            ugInvoke: null,
            btnText: '',
            guideLogo,
        };
    }

    handleGuideButtonClick() {
        const {sceneName} = this.data.get('');
        const ugInvoke = this.store.get('ugInvoke') || this.data.get('ugInvoke') || {};
        ugInvoke?.execInvoke(sceneName);
        this.emitter.emit('log', {
            type: 'click',
            value: 'openapp',
            ext: {
                source: 'topbar',
            },
        });
        this.fire('log', {
            params: {
                type: 'click',
                value: 'back_to_app',
            },
            ext: {
                click_position: 'topbar',
            },
        });
    }

    attached(): void {
        const {sceneName} = this.data.get('');
        const ugInvoke = this.store.get('ugInvoke') || this.data.get('ugInvoke') || {};
        const guideButton = this.ref('guideButton') as unknown as HTMLElement;
        const wxTagInfo = {
            wxConf: {
                wxDom: guideButton,
                onClick: () => {
                    this.emitter.emit('log', {
                        type: 'click',
                        value: 'openapp',
                        ext: {
                            source: 'topbar',
                        },
                    });
                },
            },
            sceneName,
        };
        guideButton && ugInvoke?.renderWxTag?.(wxTagInfo);

        this.emitter.emit('log', {
            type: 'show',
            value: 'openapp',
            ext: {
                source: 'topbar',
            },
        });
    }

}
